import { songTypes } from '@/types';
import { create } from 'zustand';

interface MusicPlayer {
  music: songTypes.Song;
  setMusic: (data: songTypes.Song) => void;
  // addSong: (data: songTypes.Song) => void;
}

const musicPlayerStore = create<MusicPlayer>((set) => ({
  music: {} as songTypes.Song,

  setMusic: (data: songTypes.Song) => set({ music: data }),

  // addSong: (data: songTypes.Song) => set((state) => ({ music: [data, ...state.music] })),
}));

export default musicPlayerStore;
